import { v4 as uuidv4 } from "uuid";
export class PMOTeamModel {
    constructor() {
        this.id = uuidv4();
        this.clientId = "";
        this.name = "";
        // @Type(() => PMOTeamMemberModel)
        //  teamMembers?: IPMOTeamMemberDTO[] = [];
    }
}
export default class PMOTeam extends PMOTeamModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
